import { render, staticRenderFns } from "./AppPlusIcon.vue?vue&type=template&id=5125b4c7&"
import script from "./AppPlusIcon.vue?vue&type=script&lang=js&"
export * from "./AppPlusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports